<template>
  <div
    class="top-bar"
    :class="`top-bar--${color}`"
    :style="offsetStyle"
  >
    <slot />
  </div>
</template>

<script>
  // Ниже этой ширины шапка и меню CRM переключаются на мобильную вёрстку
  const MOBILE_BREAKPOINT = 1024
  // Отступ подложки развёрнутой мобильной шапки, задан в Header.vue
  const MOBILE_WRAPPER_TOP = 75

  function supportsCssVars () {
    return typeof window.CSS !== 'undefined' &&
      typeof window.CSS.supports === 'function' &&
      window.CSS.supports('--top-bar-height', '0px')
  }

  // Полоса над страницей: висит поверх окна и опускает шапку и контент на свою
  // высоту, боковые панели не перекрывает - меню слева и степпер заказа справа.
  // Что внутри - решает AppTopBar.
  export default {
    name: 'TopBar',
    props: {
      // error - красная, success - зелёная
      color: {
        type: String,
        default: 'error',
      },
    },
    data () {
      return { resizeObserver: null }
    },
    computed: {
      offsetStyle () {
        return {
          left: `${this.$vuetify.application.left}px`,
          right: `${this.$vuetify.application.right}px`,
        }
      },
    },
    mounted () {
      // Класс на <html>, а не на v-app: какую полосу показать, решает дочерний
      // компонент, а стили сдвига шапки живут в App.vue
      document.documentElement.classList.add('with-top-bar')

      // Текст переносится на узких экранах, поэтому высоту меряем, а не задаём
      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(this.syncHeight)
        this.resizeObserver.observe(this.$el)
        return
      }

      // Safari до 13.1 и IE: следим хотя бы за шириной окна — от неё и зависит
      // число строк. В браузерах без CSS-переменных останется запасное значение
      // в одну строку из объявления рядом с var().
      window.addEventListener('resize', this.syncHeight)
      this.syncHeight()
    },
    beforeDestroy () {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect()
      } else {
        window.removeEventListener('resize', this.syncHeight)
      }

      this.setHeight(0)
      document.documentElement.classList.remove('with-top-bar')
    },
    methods: {
      syncHeight () {
        this.setHeight(this.$el.offsetHeight)
      },
      setHeight (height) {
        const value = `${height}px`

        if (supportsCssVars()) {
          document.documentElement.style.setProperty('--top-bar-height', value)
          return
        }

        // Без CSS-переменных (IE, старые Edge) двигаем то же, что и стили в App.vue
        const mobileWrapper = document.querySelector('.mobile-wrapper')

        if (mobileWrapper) {
          mobileWrapper.style.setProperty('top', `${MOBILE_WRAPPER_TOP + height}px`, 'important')
        }

        // На мобильной вёрстке полоса в потоке — шапку и обёртку не трогаем
        if (window.innerWidth <= MOBILE_BREAKPOINT) {
          return
        }

        const wrap = document.querySelector('.v-application--wrap')
        const appBar = document.querySelector('.v-app-bar')

        if (wrap) {
          wrap.style.paddingTop = value
        }

        // У шапки в App.vue стоит !important, поэтому и здесь он нужен
        if (appBar) {
          appBar.style.setProperty('top', value, 'important')
        }
      },
    },
  }
</script>

<style scoped lang="less">
.top-bar {
  position: fixed;
  top: 0;
  right: 0;
  // Выше шапки и контента, но ниже оверлея шторок (7) — под ним полоса
  // должна затемняться вместе со страницей
  z-index: 6;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  padding: 6px 16px;
  color: #fff;
  font-size: 14px;
  line-height: 1.3;
  text-align: center;

  &--error {
    background-color: @color-error;
  }

  &--success {
    background-color: @color-success;
  }

  // Ниже mobile-breakpoint меню прячется, а шапка становится обычным блоком в
  // потоке — фиксированная полоса накрывала бы её при прокрутке. Встаём в поток.
  .media-lg({
    position: static;
  });

  .media-sm({
    font-size: 13px;
    padding: 8px 12px;
  });
}
</style>
